import { render, staticRenderFns } from "./TabsQa.vue?vue&type=template&id=5fbad560&scoped=true&"
import script from "./TabsQa.vue?vue&type=script&lang=js&"
export * from "./TabsQa.vue?vue&type=script&lang=js&"
import style0 from "./TabsQa.vue?vue&type=style&index=0&id=5fbad560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbad560",
  null
  
)

export default component.exports